import { render } from "./bs-temp-grunt-view.vue?vue&type=template&id=5cb7223c"
import script from "./bs-temp-grunt-view.vue?vue&type=script&setup=true&lang=js"
export * from "./bs-temp-grunt-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-nsi/bs-temp-grunt-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cb7223c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cb7223c', __exports__)) {
    api.reload('5cb7223c', __exports__)
  }
  
  module.hot.accept("./bs-temp-grunt-view.vue?vue&type=template&id=5cb7223c", () => {
    api.rerender('5cb7223c', render)
  })

}


export default __exports__